module.exports = __webpack_public_path__ + "static/media/calendar.aec3e5d4.svg";